/* eslint-disable no-underscore-dangle */

export function SET_USER(state, user) {
  state.user = user.user;
  state.isLogged = true;
  state._id = user._id;
  state.unique_id = user.unique_id;
  state.is_assist_mode = user.is_assist_mode;
  state.is_allow_credits = user.is_allow_credits;
  state.must_change_password = user.must_change_password === true;
}

export function LOGOUT(state) {
  state.user = null;
  state.isLogged = false;
  state.token = null;
  state._id = null;
  state.unique_id = null;
  state.email = null;
  state.name = null;
  state.countryName = null;
  state.phone = null;
  state.countryPhoneCode = null;
  state.wallet = null;
  state.overdraft = null;
  state.picture_url = null;
  state.pre_time = null;
  state.is_active_shipments = null;
  state.is_active_multi_stops = null;
  state.is_corporate_master = null;
  state.is_used_google_maps_service = null;
  state.is_assist_mode = null;
  state.must_change_password = false;
  state.is_corporate_api_partner = null;
  state.is_allowed_corporate_api_partner = null;
  state.is_allowed_corporate_shipment_api = null;
  state.associated_panels = null;
  state.sales_executive_phone = null;
  state.sales_executive_country_phone_code = null;
  state.is_billing_incomplete = null;
  state.walletExcess = 0;
  state.walletExcessCurrency = null;
  state.is_internal = null;

  // Resetear el dashboard
  this.commit('dashboard/RESET_DASHBOARD');
  state.is_allow_credits = null;
  state.canCreateTrips = false;
}

export function SET_TOKEN(state, token) {
  state.token = token;
}

export function SET_ME(state, me) {
  state.email = me.email;
  state.name = me.name;
  state.countryName = me.countryName;
  state.phone = me.phone;
  state.countryPhoneCode = me.countryPhoneCode;
  state.wallet = me.wallet;
  state.overdraft = me.overdraft;
  state.pre_time = me.pre_time;
  state.admin_phone = me.admin_phone;
  state.admin_email = me.admin_email;
  state.picture_url = me.picture_url;
  state.is_active_shipments = me.is_active_shipments;
  state.is_active_multi_stops = me.is_active_multi_stops;
  state.is_corporate_master = me.is_corporate_master;
  state.is_used_google_maps_service = me.is_used_google_maps_service;
  state.is_allowed_corporate_api_partner = me.is_allowed_corporate_api_partner;
  state.is_corporate_api_partner = me.is_corporate_api_partner;
  state.is_allowed_corporate_shipment_api = me.is_allowed_corporate_shipment_api;
  state.is_allow_credits = me.is_allow_credits;
  state.canCreateTrips = me.canCreateTrips ?? false;
  state.walletExcess = me.walletExcess ?? 0;
  state.walletExcessCurrency = me.walletExcessCurrency ?? null;
  state.updated_at = me.updated_at;
  state.associated_panels = me.associated_panels;
  state.sales_executive_phone = me.sales_executive_phone;
  state.sales_executive_country_phone_code = me.sales_executive_country_phone_code;
  state.must_change_password = me.must_change_password === true;
  // Persist assist-mode on refresh (signIn already sets it via SET_USER, but
  // me/meNotLoading now also receive it from the /me response)
  if (me.is_assist_mode !== undefined) {
    state.is_assist_mode = me.is_assist_mode === true;
  }
  state.times_visited_invoice_ad = me.times_visited_invoice_ad;
  state.hide_invoice_ad = me.hide_invoice_ad;
  state.is_internal = me.is_internal ?? false;
}

export function SET_PERMISSIONS(state, permissions) {
  state.is_active_shipments = permissions.is_active_shipments;
  state.is_active_multi_stops = permissions.is_active_multi_stops;
  state.is_corporate_master = permissions.is_corporate_master;
  state.is_allow_credits = permissions.is_allow_credits;
  state.is_corporate_api_partner = permissions.is_corporate_api_partner;
  state.is_allowed_corporate_shipment_api = permissions.is_allowed_corporate_shipment_api;
}

export function SET_LANG(state, lang) {
  state.lang = lang;
}

export function SET_BILLING_INCOMPLETE(state, value) {
  state.is_billing_incomplete = value;
}
